import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import BasePureComponent from 'utils/BasePureComponent'
import { retrieveUser } from 'utils/auth'
import request from 'utils/request'

import { reverse } from 'routes'

import DropDown from './DropDown/index'

import { updateUser } from 'reducers/global/user/actions'

import { USER_PROFILE_URL } from 'constants'

import ClaimModal from 'modals/ClaimModal'

import './style.scss'


const images = {
  noImage: require('img/users/notUser.gif')
}


export class Header extends BasePureComponent {

  constructor(props) {
    super(props)

    this.state = {}
    this._bind('_retrieveUser', '_showNewSinister')
  }



  componentDidMount() {
    this.props.updateUser(retrieveUser())
    this._retrieveUser()
  }

  _retrieveUser() {
    const currentUser = retrieveUser()
    request(USER_PROFILE_URL(currentUser.uuid))
    .then(({user}) => {
      this.props.updateUser(user)
    })
    .catch(() => {
      this.props.updateUser(currentUser)
    })
  }

  _showNewSinister () {
    this.context.toggleModal(true,
      <ClaimModal />
    )
  }

  render() {
    const profilePhoto = this.props.user.picture || images.noImage
    const user = this.props.user
    const bgImage = {
      'backgroundImage': `url(${profilePhoto})`
    }
    return (
      <header className="bg-white-color d-flex justify-content-between align-items-center">
        <div className="navigation d-inline-flex align-items-center">
          <div className="navigation-element d-flex align-items-left flex-column justify-content-center">
            <p className="dashboard-head">Administración de pólizas de seguro</p>
            <p className="dashboard-title bold-text cl-primary-color">Dashboard</p>
          </div>
          <div className="navigation-element add-client d-inline-flex align-items-center">
            <span className="material-icons cl-achromatic-c-color">person_add</span>
            <Link to={reverse('clients:new')} className="new-client-link cl-achromatic-c-color bold-text">Agregar nuevo cliente</Link>
          </div>
          <div className="navigation-element add-sinister d-inline-flex align-items-center">
            <span className="material-icons cl-achromatic-c-color">report_problem</span>
            <p onClick={this._showNewSinister} className="new-client-link cl-achromatic-c-color bold-text">Iniciar siniestro</p>
          </div>
          <div className="navigation-element add-sinister d-inline-flex align-items-center">
            <span className="material-icons cl-achromatic-c-color">picture_as_pdf</span>
            <Link to={reverse('consent_generator')} className="new-client-link cl-achromatic-c-color bold-text">Reporte de brokers</Link>
          </div>
        </div>
        <div className="user-config d-inline-flex user-dashboard-data align-items-center justify-content-between">
          <p className="user-name cl-achromatic-c-color">{`${user.first_name} ${user.last_name}`}</p>
          <div className="user-image" style={bgImage}>
          </div>
          <DropDown />
        </div>
      </header>
    )
  }
}

Header.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    user: state.user.get('user')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUser: (user) => dispatch(updateUser(user))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/Header/index.js